// extracted by mini-css-extract-plugin
module.exports = {"ImageGallery":"ImageGallery_ImageGallery__2JpE1","ModalImg":"ImageGallery_ModalImg__1WcLw"};